"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _default = {
  ALLOW_ONCE: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  ALLOW_MULTIPLE: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.SUCCEEDED, _RequestStatusTypes.default.FAILED]
};
exports.default = _default;
module.exports = exports.default;